import { render, staticRenderFns } from "./RelatePayOrder.vue?vue&type=template&id=68dd854c&"
import script from "./RelatePayOrder.vue?vue&type=script&lang=js&"
export * from "./RelatePayOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports